import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export function Breadcrumbs({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="mb-4" data-testid="breadcrumbs">
      <ol className="flex items-center gap-1 text-sm text-stone-500 flex-wrap">
        <li className="flex items-center gap-1">
          <Link to="/" className="hover:text-[#D4AF37] transition-colors flex items-center gap-1" aria-label="Home">
            <Home className="h-3.5 w-3.5" />
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={item.label} className="flex items-center gap-1">
            <ChevronRight className="h-3 w-3 text-stone-300 flex-shrink-0" />
            {item.href && index < items.length - 1 ? (
              <Link to={item.href} className="hover:text-[#D4AF37] transition-colors truncate max-w-[180px]">
                {item.label}
              </Link>
            ) : (
              <span className="text-[#1A1A1A] font-medium truncate max-w-[220px]" aria-current="page">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
